var map = {
	"./icon_note_discus_0.png": "OE/w",
	"./icon_note_discus_1.png": "7Ynk",
	"./icon_note_discus_2.png": "rbKA",
	"./icon_note_discus_3.png": "DsLt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "nY+1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon ^\.\/icon_note_discus_.*\.png$
// module id = nY+1
// module chunks = 96